import autoComplete from "@tarekraafat/autocomplete.js";
import { TagManager } from "@ThirdParty/TagManager";
import { Validation } from "@Validation/Validation";

export class SearchBase
{
	private AutoCompleteForm: autoComplete;
	private BtnClearSearch: HTMLButtonElement;
	private FrmSearch: HTMLFormElement;
	private TxtSearch: HTMLInputElement;

	constructor()
	{
		this.Initialize();
	}

	private Initialize = (): void =>
	{
		this.ConfigureSearch();
		this.ConfigureAutoComplete();
	};

	private ClearSearchHandler = (): void =>
	{
		this.TxtSearch.value = "";
		this.ClearSearchToggle();
	};

	private ClearSearchToggle = (): void =>
	{
		const btnClearSearch = this.BtnClearSearch;
		const txtSearch = this.TxtSearch;
		let display = "none";

		if (txtSearch.value.length > 0)
		{
			display = "";
		}

		btnClearSearch.style.display = display;
	};

	private ConfigureAutoComplete = (): void =>
	{
		this.AutoCompleteForm = new autoComplete({
			selector: "#txtSearch",
			wrapper: false,
			placeHolder: this.TxtSearch.getAttribute("placeholder"),
			data: {
				src: async (): Promise<any> =>
				{
					try
					{
						// Trim leading and trailing spaces
						const query = this.TxtSearch.value.trim();

						if (query !== "")
						{
							// Fetch Data from external Source
							const source = await fetch(`/api/searchterm/getresults?term=${query}`);

							// Data is array of `Objects` | `Strings`
							const data = await source.json();

							return data;
						}
						else
						{
							return [];
						}
					}
					catch (error)
					{
						return error;
					}
				},

				// Data 'Object' key to be searched
				keys: ["label"]
			},
			resultItem: {
				element: (element, data): void =>
				{
					element.innerHTML = `<a class="dropdown-item" href="${data.value.url}">${data.match}</a>`;
				},
				highlight: true
			},
			resultsList: {
				id: "autoCompleteResults",
				class: "dropdown-menu w-100 top-100",
				maxResult: 10,
				tabSelect: true,
				noResults: false
			},
			submit: true
		});

		this.AutoCompleteForm.input.addEventListener("selection", this.SelectAutoCompleteEntry);
	};

	private ConfigureSearch = (): void =>
	{
		this.BtnClearSearch = document.getElementById("btnClearSearch") as HTMLButtonElement;
		this.FrmSearch = document.getElementById("frmSearch") as HTMLFormElement;
		this.TxtSearch = document.getElementById("txtSearch") as HTMLInputElement;

		if (this.BtnClearSearch !== null)
		{
			this.BtnClearSearch.addEventListener("click", this.ClearSearchHandler, false);
		}

		if (this.FrmSearch !== null)
		{
			this.FrmSearch.addEventListener("submit", this.SearchHandler, false);
		}

		if (this.TxtSearch !== null)
		{
			this.TxtSearch.addEventListener("keyup", this.ClearSearchToggle, false);
		}
	};

	private SearchHandler = (e: Event): boolean =>
	{
		if (Validation.SiteSearch(this.TxtSearch.value))
		{
			TagManager.Search(this.TxtSearch.value);
			return true;
		}
		else
		{
			e.preventDefault();
			return false;
		}
	};

	private SelectAutoCompleteEntry = (e): void =>
	{
		this.AutoCompleteForm.input.blur();
		TagManager.Search(e.detail.selection.value.label);
		window.location.href = e.detail.selection.value.url;
	};
}